import * as Yup from 'yup';
import isEmailValidator from 'validator/lib/isEmail';

const mfaValidationSchema = (needsVerificationCode: boolean) => {
  const verificationCode = Yup.string()
    .trim()
    .nullable()
    .test('verificationCode', 'validation.validVerificationCode', (value) =>
      value ? value.length === 6 : true
    );

  return Yup.object({
    email: Yup.string()
      .max(50, 'validation.lessThan50Chars')
      .when('channel', {
        is: 'email',
        then: Yup.string()
          .required('validation.fieldRequired')
          .test('is-valid', 'validation.validEmail', (value) =>
            value ? isEmailValidator(value) : false
          ),
      })
      .test('is-valid', 'validation.validEmail', (value) =>
        value ? isEmailValidator(value) : true
      ),
    mobileNumber: Yup.string()
      .max(50, 'validation.lessThan50Chars')
      .when('channel', {
        is: 'sms',
        then: Yup.string().required('validation.fieldRequired'),
      })
      .when('banking', {
        is: true,
        then: Yup.string().required('validation.fieldRequired'),
      }),
    verificationCode: needsVerificationCode
      ? verificationCode.required('validation.fieldRequired')
      : verificationCode,
    scopes: Yup.array(),
  });
};

export default mfaValidationSchema;
